export const ADMIN_API_URL = `https://us-central1-winmoneykey.cloudfunctions.net/admins`;
export const API_URL = `https://us-central1-winmoneykey.cloudfunctions.net/`;


// export const ADMIN_API_URL = `https://us-central1-dikeff-core-b908e.cloudfunctions.net/admins`;
// export const API_URL = `https://us-central1-dikeff-core-b908e.cloudfunctions.net/`;
